import script from "./RolFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./RolFormView.vue?vue&type=script&setup=true&lang=js"

import "./RolFormView.vue?vue&type=style&index=0&id=2e997c17&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e997c17"]])

export default __exports__